import { ReactNode } from 'react'

import Paper from 'shared/ui/Paper'
import Title from 'shared/ui/Title'

interface Props {
  children: ReactNode
  title: string
}

const UserKeyAccessWrapper = ({ children, title }: Props) => {
  return (
    <Paper className={`flex-1 self-baseline flex flex-col py-[24px]`}>
      <Title
        level={4}
        className="!px-[24px] !mb-0 !font-bold !leading-[28x] !text-[20px] !text-gray"
      >
        {title}
      </Title>
      {children}
    </Paper>
  )
}

export default UserKeyAccessWrapper
